export default "__VITE_ASSET__B$Ck5pnB__"